import isEmpty from "lodash/isEmpty";
import { useCalendarGridScope } from "PFApp/booking/parts/hooks";
import { usePastDatesStateContext } from "PFApp/booking/parts/overview/booking_module_calendar/booking_calendar/past_dates_context";
import { CalendarView, Row } from "PFApp/booking/types";
import { CalendarRoot } from "PFApp/booking/types/calendar_root";
import { useProfilesBookings, UseProfilesBookingsReturn } from "PFCore/hooks/queries/profile";
import { useMemo } from "react";

import { isRowContainingBookings, mapToProfileWithActivityId } from "./use_row_bookings.utils";

type UseRowBookings = {
  calendarRoot: CalendarRoot;
  view: CalendarView | null;
  isSmartPlannerView: boolean;
  allBookingsModeRowsState: Record<string, "all" | "partial" | "off" | "unset" | undefined> | null;
  rowsByKey: Record<string, Row>;
  rows: Row[];
};

export const useRowBookings = ({
  calendarRoot,
  view,
  isSmartPlannerView,
  allBookingsModeRowsState,
  rowsByKey,
  rows
}: UseRowBookings): UseProfilesBookingsReturn => {
  const { pastFetchesCount } = usePastDatesStateContext();

  const profilesWithActivityId = useMemo(
    () =>
      rows
        .filter((row) => isRowContainingBookings(row, calendarRoot, view))
        .map((row) => mapToProfileWithActivityId(row, rowsByKey, calendarRoot, allBookingsModeRowsState)),
    [rows, calendarRoot, allBookingsModeRowsState, view, rowsByKey]
  );
  const dateRange = useCalendarGridScope({
    pastFetchesCount
  });

  return useProfilesBookings({
    profiles: profilesWithActivityId,
    dateRange,
    enabled: !isEmpty(profilesWithActivityId),
    withDurationBreakdown: view === CalendarView.WallPlanner || isSmartPlannerView
  });
};
